const AUTH_USER_SET = 'AUTH_USER_SET';

export default function authUser(state=null, action) {
  switch(action.type) {
    case AUTH_USER_SET:
      return action.authUser
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authUser.js